import SidePanel from '@monofront/design-system/organisms/SidePanel';
import { useTranslations } from 'next-intl';
import React from 'react';
import ProgressBar from '@monofront/design-system/components/ProgressBar/ProgressBar';
import { useIntlFormatter } from '@hooks/useIntlFormatter';

interface ISavingsSidePanel {
  isOpen: boolean;
  onClose: () => void;
  dataTestId?: string;
  subscriptionAmount: number;
  savingsAmount: number;
}

const SavingsSidePanel: React.FC<ISavingsSidePanel> = ({
  isOpen,
  onClose,
  dataTestId,
  subscriptionAmount,
  savingsAmount,
}) => {
  const intlFormatter = useIntlFormatter({ trailingZeroDisplay: 'auto' });
  const tCheckout = useTranslations('Checkout');

  const profitabilityRate = (savingsAmount / subscriptionAmount) * 100;

  return (
    <SidePanel.SidePanel isOpen={isOpen} onClose={onClose}>
      <SidePanel.SidePanelHeader onClose={() => onClose()}>
        <h1
          className="tw-lf-title-xs desktop:tw-lf-title-sm"
          data-testid={dataTestId}
        >
          {tCheckout('membershipSavingsSidePanelTitle')}
        </h1>
      </SidePanel.SidePanelHeader>
      <SidePanel.SidePanelBody>
        <p className="tw-lf-body-regular-md tw-text-center">
          {tCheckout('membershipSavingsSidePanelGaugeLeadingText')}
        </p>

        <p className="tw-lf-title-md tw-mt-2 tw-text-center tw-text-blue-600">
          {intlFormatter.formatCurrency(savingsAmount)}
        </p>

        {profitabilityRate >= 25 && (
          <>
            <p className="tw-lf-body-regular-md tw-mt-4 tw-text-center">
              {tCheckout('membershipSavingsSidePanelProgressText')}
            </p>

            <div className="tw-mt-2">
              <ProgressBar
                previousProgress={0}
                currentProgress={profitabilityRate}
                height={25}
                isValueDisplayed
                withAnimation
                hasBackground
                animationDuration={1}
                aria-hidden="true"
              />
            </div>
          </>
        )}

        <p className="tw-lf-body-regular-md tw-mt-8">
          {tCheckout('membershipSavingsSidePanelDescription')}
        </p>
      </SidePanel.SidePanelBody>
      <SidePanel.SidePanelFooter>
        <button
          className="tw-lf-button tw-lf-button-primary tw-lf-button-md tw-w-full"
          onClick={onClose}
        >
          {tCheckout('membershipPlanSidePanelButtonLabel')}
        </button>
      </SidePanel.SidePanelFooter>
    </SidePanel.SidePanel>
  );
};

export default SavingsSidePanel;
